import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import MainIndex from '../components/MainIndex';
import Auth from '../components/Auth';
import AddSAML from '../components/AddSAML';
import OidcApp from '../components/OidcApp';
import OidcEntraIdEamApp from '../components/OidcEntraIdEamApp';
import WsFederationApp from '../components/WsFederationApp';
import DeleteSAML from '../components/DeleteSAML';
import ListSAML from '../components/ListSAML';
import './App.scss';
import CustomizeGlobalIdpSettings from '../components/CustomizeGlobalIdpSettings';
import Logout from '../components/Logout';
import AddAzureAD from '../components/AddAzureAD';
import GetAzureAdList from '../components/AzureAdList';
import { AppCheck } from '../components/AppCheck';

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App-container">
          <Switch>
            <Route exact path="/" component={MainIndex} />
            <Route path="/addsaml/:applicationId?" component={AddSAML} />
            <Route exact path="/oidcapp/entraideam/:applicationId?" component={OidcEntraIdEamApp}/>
            <Route exact path="/oidcapp/:applicationId?" component={OidcApp} />
            <Route path="/wsfedapp/:applicationId?" component={WsFederationApp} />
            <Route path="/listsaml" component={ListSAML} />
            <Route path="/checkapp" component={AppCheck} />
            <Route path="/deletesaml" component={DeleteSAML} />
            <Route path="/auth" component={Auth} />
            <Route path="/customization" component={CustomizeGlobalIdpSettings} />
            <Route path="/logout" component={Logout} />
            <Route path="/addazuread" component={AddAzureAD} />
            <Route path="/getazureadlist" component={GetAzureAdList} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
